import React from 'react'
import { useLanguage } from '@/contexts/LanguageContext'

// Partner logos
import twsLogo from '@/assets/partners/tws_logo.png'
import egeEsasLogo from '@/assets/partners/ege_esas_logo.jpeg'
import kosgebLogo from '@/assets/partners/kosgeb_logo.png'
import trSuAltiLogo from '@/assets/partners/tr_su_alti_logo.png'
import birkanSuLogo from '@/assets/partners/birkan_su_logo.png'
import tubitakLogo from '@/assets/partners/tubitak_logo.png'
import zorbeyLogo from '@/assets/partners/zorbey_logo.png'

const Partners: React.FC = () => {
  const { t } = useLanguage()
  const partners = [
    {
      id: 1,
      name: 'TWS',
      logo: twsLogo,
      alt: 'TWS Logo'
    },
    {
      id: 2,
      name: 'Ege Esas',
      logo: egeEsasLogo,
      alt: 'Ege Esas Logo'
    },
    {
      id: 3,
      name: 'KOSGEB',
      logo: kosgebLogo,
      alt: 'KOSGEB Logo'
    },
    {
      id: 4,
      name: 'TR Sualtı',
      logo: trSuAltiLogo,
      alt: 'TR Sualtı Logo'
    },
    {
      id: 5,
      name: 'Birkan Su',
      logo: birkanSuLogo,
      alt: 'Birkan Su Logo'
    },
    {
      id: 6,
      name: 'TÜBİTAK',
      logo: tubitakLogo,
      alt: 'TÜBİTAK Logo'
    },
    {
      id: 7,
      name: 'Zorbey',
      logo: zorbeyLogo,
      alt: 'Zorbey Logo'
    }
  ]

  // Duplicate once for seamless loop
  const duplicatedPartners = [...partners, ...partners]

  return (
    <section className="pt-6 pb-8 md:pt-10 md:pb-12 bg-white border-t border-secondary-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 md:mb-10">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-secondary-900 mb-2 md:mb-4">
            {t.home.partnerships.title}
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-secondary-600 max-w-2xl mx-auto">
            {t.home.partnerships.subtitle}
          </p>
        </div>

        {/* Scrolling Partners Container */}
        <div className="relative overflow-hidden mb-4 md:mb-6 partners-marquee">
          {/* Gradient overlays */}
          <div className="absolute left-0 top-0 bottom-0 w-12 md:w-20 bg-gradient-to-r from-white to-transparent z-10"></div>
          <div className="absolute right-0 top-0 bottom-0 w-12 md:w-20 bg-gradient-to-l from-white to-transparent z-10"></div>
          
          {/* Scrolling animation */}
          <div className="partners-track flex space-x-6 md:space-x-12 lg:space-x-16 py-2 md:py-4">
            {duplicatedPartners.map((partner, index) => (
              <div
                key={`${partner.id}-${index}`}
                className="flex-shrink-0 w-14 h-14 md:w-20 md:h-20 lg:w-24 lg:h-24 flex items-center justify-center"
              >
                <img
                  src={partner.logo}
                  alt={partner.alt}
                  className="max-w-full max-h-full object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Partners
